export const DropDownItems = [
    {
      title: 'LANDSCAPES/LANDMARKS',
      path: '/nature',
      cName: 'dropdown-link',
    },
  
    {
      title: 'BLOOMS',
      path: '/florals',
      cName: 'dropdown-link',
    },
    {
      title: 'WILD-LIFE',
      path: '/wildlife',
      cName: 'dropdown-link',
    },
  
    {
      title: 'MASTER-COPY',
      path: '/mastercopies',
      cName: 'dropdown-link',
    },
    {
      title: 'PORTRAITS/FIGURATIVE',
      path: '/portraits',
      cName: 'dropdown-link',
    },
    {
      title: 'PET PORTRAIT ',
      path: '/petportraits',
      cName: 'dropdown-link',
    },
    {
      title: 'SOLD',
      path: '/sold',
      cName: 'dropdown-link',
    },
  ];
  
  // dropdown for contact service
  
  const ServiceOption = [
    {
      label: 'Commissions',
    },
  
    {
      label: 'Portrait',
    },
    {
      label: 'Workshop',
    },
    {
      label: 'Classes',
    },
    {
      label: 'General',
    },
  ];
  
  export default ServiceOption;